import apiService from 'src/enviroment';
import { loaderService } from 'src/services/loaderService';

const putScore = async (params) => {
  loaderService.show();
  const response = await apiService.put(
    'insights/admin/entradas/sistema/',
    params,
  );
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const getQuestions = async () => {
  loaderService.show();
  const response = await apiService.get('/insights/admin/preguntas/');
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

export { putScore, getQuestions };
